module.exports = __webpack_public_path__ + "static/about-future-work-4-77c8b38ddbdc4f93b6899f3d86b8a1f8.jpg";